import {
  Heart, Scissors, Home, GraduationCap, Cloud, Code, Brain, Shield,
  Package, Hammer, Gem, Flame, Gift, Coffee, Sparkles, Star, Grid3x3,
  Shirt, CreditCard, Users, Award, MessageCircle
} from 'lucide-react';
import {
  FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaYoutube, FaTiktok,
  FaPinterest, FaEtsy, FaAmazon, FaSnapchat, FaWhatsapp, FaStore
} from 'react-icons/fa';

export const iconMap = {
  Heart, Scissors, Home, GraduationCap, Cloud, Code, Brain, Shield,
  Package, Hammer, Gem, Flame, Gift, Coffee, Sparkles, Star, Grid3x3,
  Shirt, CreditCard, Users, Award, MessageCircle
};

export const socialIconMap = {
  facebook: FaFacebook, instagram: FaInstagram, twitter: FaTwitter,
  linkedin: FaLinkedin, youtube: FaYoutube, tiktok: FaTiktok,
  pinterest: FaPinterest, snapchat: FaSnapchat, whatsapp: FaWhatsapp
};

export const socialBrandColors = {
  facebook: '#1877F2', instagram: '#E4405F', twitter: '#1DA1F2',
  linkedin: '#0A66C2', youtube: '#FF0000', tiktok: '#000000',
  pinterest: '#BD081C', snapchat: '#FFFC00', whatsapp: '#25D366'
};

export const marketplaceIconMap = {
  etsy: FaEtsy, amazon: FaAmazon, ebay: FaStore
};

export const marketplaceBrandColors = {
  etsy: '#F16521', amazon: '#FF9900', ebay: '#E53238'
};
